// 구주 스페인어
export default {
  LandingPage: {
    intro_sub: 'Dale una segunda vida al embalaje y protege el medio ambiente.',
    title: 'Página de destino',
    sequence1_1: 'Únete a nosotros para reducir residuos convirtiendo',
    sequence1_2:
      'la caja de tu producto en cosas útiles y ayúdanos a crear un ambiente más sostenible. Baja con tu ratón para ver el primer paso',
    sequence2_1: 'Presentamos Samsung Upcycle-Packaging',
    sequence2_2: `Una caja de producto especialmente diseñada para contribuir con el medio ambiente. Convierte tu caja en varios elementos decorativos para tu casa`,
    sequence3_1: 'Sigue la línea de puntos impresa en la caja',
    sequence3_2: `Corta la caja siguiendo las instrucciones y móntalas para crear un asombroso objeto`,
    sequence4_1: 'Selecciona el objeto que quieres realizar',
    sequence4_2:
      'Baja con el ratón para seleccionar el modelo de caja de tu producto. Encuentra varias opciones de posibles diseños para ti. Y empieza con la elaboración del objeto que has elegido',
    selectBox: 'Seleccione su producto',
    moreActivity:
      'Para mayor información sobre las actividades sostenibles en Samsung',
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet02:'Soundbar Set 2',
    SoundbarSet01:'Soundbar Set 1',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/es/sustainability/overview/',
    //moreActivityLink:'https://www.samsung.com/es/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/es/sustainability/overview/',
    footer: 'Copyright ⓒ 2019-2021 SAMSUNG Todos los derechos reservados ',
    // <br/>
    // Este sitio web se ve mejor con Internet Explorer 11, Chrome, Safari y los navegadores mas modernos.`
  },
  ProductPage: {
    selectDesign: 'Seleccione un diseño para crear',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Consola de TV',
    StorageBox: 'Caja de almacenamiento',
    MagazineRack: 'Estante para revistas',
    CatHouse: 'Casa para gatos',
    CatTunnel: 'Túnel de gato',
    BookShelf: 'Librería',
    DeskShelf: 'Balda de escritorio',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: 'Material de oficina',
    CoinBank: 'Banco de monedas',
    MobileScanner:'Soporte de escáner smartphone',
    TabletScanner:'Soporte para escáner de tablet',
    PetStairs:'Escaleras para mascotas',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'min',
    all:'ALL',
    in: 'pulgadas',
    inOnly: 'en sólo',
    allBoxSize: 'Todos los tamaños de cajas',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'instrucciones',
    prepare: 'Preparar la caja',
    LetsDesign: 'Diseñemos',
    drawParts: 'Dibuje piezas en la caja',
    note1:
      'Tenga en cuenta que la posición del gráfico puede variar por país y por tamaño',
    note2: 'Esboce todo el dibujo primero para que quepa en la caja',
    numberSpace: 'número = espacios entre lo puntos',
    diagonal: 'diagonal',
    LEFT: 'IZQUIERDA',
    RIGHT: 'DERECHA',
    TOP: 'ARRIBA',
    TOP1: 'ARRIBA 1',
    TOP2: 'ARRIBA 2',
    BACK: 'ATRÁS',
    MIDDLE: 'CENTRO',
    MIDDLE2: 'CENTRO 2',
    BOTTOM: 'ABAJO',
    FRONT: 'DELANTE',
    SIDE: 'LADO',
    secondSIDE: 'SEGUNDO LADO',
    secondSIDE1: 'SEGUNDO LADO 1',
    secondSIDE2: 'SEGUNDO LADO 2',
    LEG: 'PATA', //update
    JOINT: 'UNIÓN', //update
    FACE: 'SUPERFICIE', //update
    DRAWERBOTTOM: 'FONDO DEL CAJÓN', //update
    DRAWERSIDE: 'LADO DEL CAJÓN', //update
    NOSE: 'PICO', //update
    HANDLE: 'MANGO', //update
    BOTTOMSIDE: 'LADO INFERIOR', //update
    TOPSIDE: 'LADO SUPERIOR', //update
    WING: 'ALA', //update
    cutAndAssemble: 'Cortemos y ensamblemos',
    beCareful: 'Tenga cuidado de no cortarse al utilizar el cúter',
    cutOutParts: 'Piezas troqueladas',
    assemble: 'Ensamblar',
    Assemblyguide: 'Guía de montaje', //update
    fold: 'Ejemplo plegable',
    foldGuide: 'Usa el borde de los muebles al doblar el cartón',
    foldGuideDezeen:
      'Presione la línea de puntos del cartón con herramientas para plegar varias veces para ayudar a que se doble el cartón',
    glue: 'Ponga pegamento o cinta por igual en la superficie', //update
    cable: 'Utilice sujetacables para las conexiones', //update
    done: '¡Terminado!',
    goBack: 'Volver al menú principal',
  },
  CautionPage: {
    CAUTION: 'PRECAUCIÓN',
    needItem: 'Tendrá que guardar estos artículos',
    children: 'Los niños deben estar acompañados por adultos',
    mat:
      'Ponga una manta sobre el suelo para prevenir arañazos durante el proceso',
    doNotPutHeavyThing:
      'No pise ni se siente en estos muebles e intente No poner cosas pesadas sobre ellos',
    doNotThrow:
      'No lance ni golpee muebles hacia nada que incluya personas y animales',
    stayAwayFlame: 'Aléjese de las llamas',
    stayAwayWater: 'No se acerque al agua ni a la humedad',
    mayDamaged: '* La caja de TV puede dañarse durante el proceso de envío',
    companyDoestResponsible:
      '* La compañía no tiene ninguna responsabilidad por roturas o lesiones durante este trabajo',
    cannotBeReturned:'',
    understand: 'De acuerdo, entendido',
  },
  PrivacyPolicy: {
    title: 'Política de privacidad',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Redoblamos nuestro compromiso con la sostenibilidad con nuestros nuevos embalajes ecológicos.',
      text2:
        'Hemos utilizado menos papel y tinta para los embalajes de los televisores que se pueden utilizar como objetos  del hogar.',
      text2_special:'',
      text3: 'Seleccione los botones a continuación para averiguar más.',
    },
    greenIn: {
      title: 'Cambio a embalaje de TV ecológico',
      subtitle1: 'Información del producto sin tinta',
      subtitle2: 'Mejora del ecoembalaje',
      desc: 'Busque el nombre del modelo para mayor información',
      descM: '*Take a photo of the TV model number',
      guide: 'nombre de modelo',
      button: 'Take Photo',
      button2: 'Ir a artículos del fabricante',
    },
    search: {
      guide: 'Search..',
      noResult: 'Ningún resultado',
      more: 'Más',
    },
  },
  searchCountrySelect: 'Seleccione un país para buscar'
};
